import { HttpErrorResponse } from '@angular/common/http';

// TODO: Fix translations - In the translation file, are not all possible status codes defined
// define the translation keys for the error messages OR handle the error messages in a different way

/**
 * Returns translation keys for HTTP error messages based on the error status.
 *
 * @param {HttpErrorResponse} error - The HTTP error response object.
 * @returns {{ summary: string, detail: string }} - An object containing the translation keys for the error summary and detail.
 */
export const getHttpErrorTranslationKeys = (error: HttpErrorResponse) => {
  // Check if the error status is between 400 and 599
  if (error.status >= 400 && error.status < 600) {
    return {
      summary: `errorMessages.${error.status}.summary`,
      detail: `errorMessages.${error.status}.detail`
    } as const;
  }

  // Return generic error messages if the status is not between 400 and 599
  return {
    summary: 'errorMessages.generic.summary',
    detail: 'errorMessages.generic.detail'
  } as const;
};
